import { authGuard } from 'src/services/security/auth.guard';
import { adminGuard } from 'src/services/security/admin.guard';
import { orgAdminGuard } from 'src/services/security/org-admin.guard';
import { pendingSavesGuard } from './pages/review/shared/services/pending-saves.guard';
import { LayoutComponent } from './vex/vex-layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { GuestLayoutComponent } from './vex/vex-layouts/guest-layout/guest-layout.component';
import { postDeskSwitchGuard } from './pages/review/video/lumo/post-desk/data/post-desk-switch';

export const appRoutes: VexRoutes = [
  // Pantallas de acceso (plan #66): lógica única en pages/auth/screens/, marco
  // visual por marca en pages/auth/shells/ y registro en pages/auth/brands/.
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/auth/screens/login/login.component').then(
        (m) => m.LoginComponent
      )
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/auth/screens/register/register.component').then(
        (m) => m.RegisterComponent
      )
  },
  // Confirmación del email del alta abierta (plan #66): código de 6 dígitos
  {
    path: 'register/verify',
    loadComponent: () =>
      import('./pages/auth/screens/register-verify/register-verify.component').then(
        (m) => m.RegisterVerifyComponent
      )
  },
  // Cuenta pausada por intentos fallidos (plan #66): pantalla «Sign-in paused»
  {
    path: 'login/locked',
    loadComponent: () =>
      import('./pages/auth/screens/login-locked/login-locked.component').then(
        (m) => m.LoginLockedComponent
      )
  },
  // Segundo paso del login con 2FA (plan #66): código de 6 dígitos por email
  {
    path: 'login/verify',
    loadComponent: () =>
      import('./pages/auth/screens/login-otp/login-otp.component').then(
        (m) => m.LoginOtpComponent
      )
  },
  {
    path: 'login/activateUser/:uuid',
    loadComponent: () =>
      import('./pages/auth/screens/activate-user/activate-user.component').then(
        (m) => m.ActivateUserComponent
      )
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import(
        './pages/auth/screens/forgot-password/forgot-password.component'
      ).then((m) => m.ForgotPasswordComponent)
  },
  // Invitation routes (public, no auth required)
  {
    path: 'invitation/accept/:token',
    loadComponent: () =>
      import('./pages/auth/screens/invitation-accept/invitation-accept.component').then(
        (m) => m.InvitationAcceptComponent
      )
  },
  {
    path: 'invitation/reject/:token',
    loadComponent: () =>
      import('./pages/auth/screens/invitation-reject/invitation-reject.component').then(
        (m) => m.InvitationRejectComponent
      )
  },
  {
    path: 'invitation/expired',
    loadComponent: () =>
      import('./pages/auth/screens/invitation-expired/invitation-expired.component').then(
        (m) => m.InvitationExpiredComponent
      )
  },
  // CD (Distribution Channel) invitation routes (public, no auth required)
  {
    path: 'distribution',
    loadChildren: () =>
      import('./pages/distribution/distribution.routes').then(
        (m) => m.DISTRIBUTION_ROUTES
      )
  },
  // Destino del enlace de reset por email (plan #66 F4): /password-reset?token=…
  {
    path: 'password-reset',
    loadComponent: () =>
      import(
        './pages/auth/screens/password-reset/password-reset.component'
      ).then((m) => m.PasswordResetComponent)
  },
  {
    path: 'guest',
    loadComponent: () => import('./pages/guest/home/home.component').then((m) => m.HomeComponent),
    data: {
      scrollDisabled: false
    }
  },
  {
    path: 'ata-tts-batch',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/audio/audio-to-audio/ata-tts-batch/ata-tts-batch.component').then(
            (m) => m.ATATTSBatchComponent
          ),
      },]
  },
  {
    path: 'ata-transcription-batch',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/audio/audio-to-audio/ata-transcription-batch/ata-transcription-batch.component').then(
            (m) => m.ATATranscriptionBatchComponent
          ),
      },]
  },
  {
    path: 'ata-translation-batch',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/audio/audio-to-audio/ata-translation-batch/ata-translation-batch.component').then(
            (m) => m.ATATranslationBatchComponent
          ),
      },]
  },
  {
    path: 'translation',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/text/translation/translation.component').then(
            (m) => m.TranslationComponent
          ),
      },]
  },
  {
    path: 'audio',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/audio/audio/audio.component').then(
            (m) => m.AudioComponent
          ),
      },]
  },
  {
    path: 'transcription-single',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/text/transcription-single/transcription-single.component').then(
            (m) => m.TranscriptionSingleComponent
          ),
      },]
  },
  {
    path: 'transcription-multiple',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/text/transcription-multiple/transcription-multiple.component').then(
            (m) => m.TranscriptionMultipleComponent
          ),
      },]
  },
  {
    path: 'copy-editing',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/text/copy-editing/copy-editing-review/copy-editing-review.component').then(
            (m) => m.CopyEditingReviewComponent
          ),
      },]
  },
  {
    path: 'recording-lumo',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/video/lumo/recording-lumo/recording-lumo.component').then(
            (m) => m.RecordingLumoComponent
          ),
      },]
  },
  {
    // LUMO Post Desk, full screen (links from the recording session and emails); uuid = the recording task
    path: 'lumo-post',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        // Testing only until the desk is switched on (POST_DESK_ENABLED or ?postdesk=on)
        canActivate: [postDeskSwitchGuard],
        loadComponent: () =>
          import('./pages/review/video/lumo/post-desk/page/post-desk-page.component').then(
            (m) => m.PostDeskPageComponent
          ),
      },]
  },
  {
    path: 'adaptationreview',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid/en_US',
        loadComponent: () =>
          import('./pages/review/video/dubbing/video-adaptation/video-adaptation.component').then(
            (m) => m.VideoAdaptationComponent
          ),
      }
    ]
  },
  {
    path: 'video-adaptation',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/video/dubbing/video-adaptation/video-adaptation.component').then(
            (m) => m.VideoAdaptationComponent
          ),
      }
    ]
  },
  {
    // Public unfollow page of the Communications notification emails (plan #35, F5):
    // /unfollow-conversation?token=... — no session, the HMAC token is the proof.
    path: 'unfollow-conversation',
    component: GuestLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/inbox/unfollow/unfollow-conversation.component').then(
            (m) => m.UnfollowConversationComponent
          ),
      }
    ]
  },
  {
    // TODO #42: public accept/decline page for resource-assignment requests
    // (single-use token from the review-task-requested/invite emails)
    path: 'assignment',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':token',
        loadComponent: () =>
          import('./pages/assignment/assignment-response.component').then(
            (m) => m.AssignmentResponseComponent
          ),
      }
    ]
  },
  {
    path: 'subtitle',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/video/dubbing/subtitle-review/subtitle-review.component').then(
            (m) => m.SubtitleReviewComponent
          ),
      }
    ]
  },
  {
    path: 'dubbing/select-voices',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/video/dubbing/select-voices/select-voices.component').then(
            (m) => m.SelectVoicesComponent
          ),
      }
    ]
  },
  {
    path: 'lumo-script-code',
    component: GuestLayoutComponent,
    children: [
      {
        path: ':uuid',
        loadComponent: () =>
          import('./pages/review/video/lumo/script-code/script-code.component').then(
            (m) => m.ScriptCodeReviewComponent
          )
      }
    ]
  },
  {
    path: 'tos',
    loadComponent: () => import('./pages/public/terms-of-service/terms-of-service.component').then((m) => m.TermsOfServiceComponent),
    data: {
      scrollDisabled: false
    }
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./pages/public/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
    data: {
      scrollDisabled: false
    }
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'dashboards/analytics',
        redirectTo: '/',
        pathMatch: 'full'
      },
      {
        // The old Home (pages/home) is unhooked (2026-09-29): '/' now lands on the new Home.
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        // The new Home (Dani's 28 Sep 2026 design), default since 2026-09-29.
        path: 'home',
        loadChildren: () => import('./pages/home2/home.routes')
      },
      {
        // Official projects view (the former /drawer)
        path: 'projects',
        loadChildren: () => import('./pages/projects/projects.routes')
      },
      {
        // Legacy projects view, kept reachable by URL only (no menu entry)
        path: 'projects_old',
        loadChildren: () => import('./pages/projects_old/projects.routes')
      },
      {
        path: 'create',
        loadChildren: () => import('./pages/create/create.routes')
      },
      {
        path: 'api-datatable',
        loadComponent: () => import('./pages/other/api-datatable/api-datatable.component').then(m => m.ApiDatatableComponent)
      },
      {
        path: 'review',
        canDeactivate: [pendingSavesGuard],
        children: [
          {
            path: 'adaptationreview/:uuid/en_US',
            loadComponent: () =>
              import('./pages/review/video/dubbing/video-adaptation/video-adaptation.component').then(
                (m) => m.VideoAdaptationComponent
              ),
          },
          {
            path: 'video-adaptation/:uuid',
            loadComponent: () =>
              import('./pages/review/video/dubbing/video-adaptation/video-adaptation.component').then(
                (m) => m.VideoAdaptationComponent
              ),
          },
          {
            path: 'subtitle/:uuid',
            loadComponent: () =>
              import('./pages/review/video/dubbing/subtitle-review/subtitle-review.component').then(
                (m) => m.SubtitleReviewComponent
              ),
          },
          {
            path: 'translation/:uuid',
            loadComponent: () =>
              import('./pages/review/text/translation/translation.component').then(
                (m) => m.TranslationComponent
              ),
          },
          {
            path: 'ata-transcription-batch/:uuid',
            loadComponent: () =>
              import('./pages/review/audio/audio-to-audio/ata-transcription-batch/ata-transcription-batch.component').then(
                (m) => m.ATATranscriptionBatchComponent
              ),
          },
          {
            path: 'ata-translation-batch/:uuid',
            loadComponent: () =>
              import('./pages/review/audio/audio-to-audio/ata-translation-batch/ata-translation-batch.component').then(
                (m) => m.ATATranslationBatchComponent
              ),
          },
          {
            path: 'ata-tts-batch/:uuid',
            loadComponent: () =>
              import('./pages/review/audio/audio-to-audio/ata-tts-batch/ata-tts-batch.component').then(
                (m) => m.ATATTSBatchComponent
              ),
          },
          {
            path: 'lumo-script-code/:uuid',
            loadComponent: () =>
              import('./pages/review/video/lumo/script-code/script-code.component').then(
                (m) => m.ScriptCodeReviewComponent
              )
          },
          {
            path: 'copy-editing/:uuid',
            loadComponent: () =>
              import('./pages/review/text/copy-editing/copy-editing-review/copy-editing-review.component').then(
                (m) => m.CopyEditingReviewComponent
              ),
          },
          {
            path: 'recording-lumo/:uuid',
            loadComponent: () =>
              import('./pages/review/video/lumo/recording-lumo/recording-lumo.component').then(
                (m) => m.RecordingLumoComponent
              ),
          },
          {
            // LUMO Post Desk inside the app layout; testing only until switched on
            path: 'lumo-post/:uuid',
            canActivate: [postDeskSwitchGuard],
            loadComponent: () =>
              import('./pages/review/video/lumo/post-desk/page/post-desk-page.component').then(
                (m) => m.PostDeskPageComponent
              ),
          },
          {
            path: 'transcription-single/:uuid',
            loadComponent: () =>
              import('./pages/review/text/transcription-single/transcription-single.component').then(
                (m) => m.TranscriptionSingleComponent
              ),
          },
          {
            path: 'transcription-multiple/:uuid',
            loadComponent: () =>
              import('./pages/review/text/transcription-multiple/transcription-multiple.component').then(
                (m) => m.TranscriptionMultipleComponent
              ),
          },
          {
            path: 'audio/:uuid',
            loadComponent: () =>
              import('./pages/review/audio/audio/audio.component').then(
                (m) => m.AudioComponent
              ),
          },
          {
            path: 'dubbing',
            children: [
              {
                path: 'select-voices/:uuid',
                loadComponent: () =>
                  import('./pages/review/video/dubbing/select-voices/select-voices.component').then(
                    (m) => m.SelectVoicesComponent
                  ),
              }
            ]
          }
        ]
      },
      {
        // Abel 17/9/24: Añado directory routes
        path: 'organizations',
        loadChildren: () => import('./pages/organizations/org.routes')
      },
      {
        // My Organization new page
        path: 'organizationnew',
        loadChildren: () => import('./pages/organizations/my-organization/my-organization.routes')
      },
      {
        // The rebuilt directory, which took /directories in the swap of 18 Sep 2026.
        // The folder is still called directories2: only the paths were swapped, so that
        // nothing importing from pages/directories2/shared had to move with them.
        path: 'directories',
        loadChildren: () => import('./pages/directories2/directories.routes')
      },
      {
        // The previous directory, moved aside by that swap and otherwise untouched.
        // Nothing links to it; it is reachable only by typing the address.
        path: 'directories_old',
        loadChildren: () => import('./pages/directories/directories.routes')
      },
      {
        // Old drawer URL — the drawer is the official projects view now
        path: 'drawer',
        redirectTo: '/projects',
        pathMatch: 'full'
      },
      {
        // BMG - Distribution Channels
        path: 'distribution',
        loadChildren: () => import('./pages/distribution-channels/distribution-channel.routes')
      },
      {
        // Abel 12/9/24: Añado directory routes
        path: 'contacts',
        loadChildren: () => import('./pages/users/people.routes')
      },
      {
        // Invitations management (Admin)
        path: 'invitations',
        loadChildren: () => import('./pages/invitations/invitations.routes')
      },
      {
        // Finances — Overview, Activity, Work not yet invoiced, Invoices, Quotes, Expenses, Analysis, By project,
        // By client or vendor. Sample data until the API lands (finances-demo-backend.ts), admin-only like its menu entry.
        path: 'finances',
        canActivate: [orgAdminGuard],
        loadChildren: () => import('./pages/finances/finances.routes')
      },
      {
        // Communications (Dashboard > Inbox) — the main-menu Inbox screen.
        // Front end only: every conversation is sample data, see pages/inbox/data/inbox.model.ts.
        path: 'inbox',
        loadChildren: () => import('./pages/inbox/inbox.routes')
      },
      {
        // The previous Inbox, built from the earlier Figma frame. Kept, unedited, and moved aside
        // when the new screen took /inbox — nothing links to it.
        path: 'inbox_old',
        loadChildren: () => import('./pages/inbox_old/inbox.routes')
      },
      {
        // Metadata management (Admin)
        path: 'metadata',
        loadChildren: () => import('./pages/metadata/metadata.routes')
      },
      {
        // Admin pages - restricted to user ID 229
        path: 'admin',
        loadChildren: () => import('./pages/admin/admin.routes'),
        canActivate: [adminGuard]
      },
      {
        path: '**',
        loadComponent: () =>
          import('./pages/vex/vex-pages/errors/error-404/error-404.component').then(
            (m) => m.Error404Component
          )
      }
    ],
    // Abel, 2/9/24: Dejo el authguard aquí para no liarme con cada componente.
    canActivate: [authGuard]
  }
];
